"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Radium = require("radium");
var omit = require("lodash.omit");
var react_1 = require("react");
var CheckboxInput_1 = require("./CheckboxInput");
var componentStyle = {
    base: {
        display: 'flex',
        alignItems: 'center',
        userSelect: 'none',
        ':hover': {
            cursor: 'pointer',
        },
    },
};
var Checkbox = (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (e) {
            var checked = _this.state.checked;
            _this.props.onChange(!checked);
            _this.setState({ checked: !checked });
        };
        _this.state = {
            checked: props.checked,
        };
        return _this;
    }
    Checkbox.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.checked !== this.props.checked) {
            this.setState({ checked: nextProps.checked });
        }
    };
    Checkbox.prototype.render = function () {
        var _a = omit(this.props, ['checked', 'onChange']), style = _a.style, children = _a.children, otherProps = __rest(_a, ["style", "children"]);
        var checked = this.state.checked;
        return (React.createElement("div", __assign({ style: [componentStyle.base, style], onClick: this.handleClick }, otherProps),
            React.createElement(CheckboxInput_1.CheckboxInput, { checked: checked }),
            children));
    };
    Checkbox.defaultProps = {
        checked: false,
        onChange: function () { return; },
    };
    Checkbox = __decorate([
        Radium,
        __metadata("design:paramtypes", [Object])
    ], Checkbox);
    return Checkbox;
}(react_1.PureComponent));
exports.Checkbox = Checkbox;



//////////////////
// WEBPACK FOOTER
// ./src/components/Checkbox/Checkbox.tsx
// module id = 287
// module chunks = 0